const translation = {
  // Navbar
  nav_hotel_intro: '호텔소개',
  nav_greeting: '인사말',
  nav_about: '호텔소개',
  nav_rooms: '객실안내',
  nav_services: '부대시설',
  nav_nearby: '주변안내',
  nav_refund: '환불규정',
  nav_contact: '오시는 길',
  nav_support: '고객지원',
  nav_reserve: '실시간 예약',

  // Hero
  hero_welcome: 'Welcome to Korea · Dongdaemun',
  hero_title: 'YOUNGBIN HOTEL',
  hero_subtitle: '영빈호텔에 오신것을 환영합니다',
  hero_location: 'IN DONGDAEMUN',
  hero_cta_reserve: '실시간 예약 · Reservation',
  hero_cta_rooms: '객실 안내',
  hero_slide1_label: '편안한 휴식의 공간',
  hero_slide2_label: '아늑한 객실',
  hero_slide3_label: '깔끔한 욕실 시설',
  hero_slide4_label: '동대문 도심 속 최적의 위치',
  hero_slide5_label: '여행자를 위한 영빈호텔',

  // About
  about_tag: 'WELCOME TO THE YOUNGBIN HOTEL',
  about_title: '동대문의 중심,\n영빈호텔',
  about_desc1: '서울특별시 중구 동대문 국제패션타운에 인접한 영빈호텔입니다. 동대문 쇼핑상가까지 도보 10분 거리에 위치하여 쇼핑과 관광을 동시에 즐기실 수 있습니다.',
  about_desc2: '편안하고 안락한 객실과 다양한 부대시설을 갖추고 있으며, 친절한 서비스로 여러분의 소중한 여행을 더욱 특별하게 만들어 드리겠습니다.',
  about_stat1_label: '컨시어지 서비스',
  about_stat2_label: '무료 와이파이',
  about_stat3_label: '동대문까지 도보',
  about_cta: '예약 문의하기',

  // Rooms
  rooms_tag: 'ROOM GUIDANCE',
  rooms_title: '객실 안내',
  rooms_subtitle: '편안하고 아늑한 영빈호텔의 다양한 객실을 만나보세요',
  room1_name: '싱글룸',
  room1_desc: '1인 여행객을 위한 아늑하고 실용적인 객실입니다. 동대문 관광의 베이스캠프로 최적의 선택입니다.',
  room2_name: '트윈룸',
  room2_desc: '싱글 침대 2개가 배치된 객실로, 2인 여행객에게 적합합니다. 넓고 쾌적한 공간에서 편안한 휴식을 즐기세요.',
  room3_name: '더블룸',
  room3_desc: '더블 침대 1개가 배치된 객실로, 커플 또는 1~2인 여행객에게 적합합니다. 아늑하고 편안한 분위기를 제공합니다.',
  room4_name: '트리플룸',
  room4_desc: '싱글 침대 3개가 배치된 넓은 객실로, 3인 여행객에게 최적입니다. 가족 여행이나 소그룹 여행에 적합합니다.',
  room5_name: '온돌룸',
  room5_desc: '한국 전통 온돌 바닥 난방 방식의 객실입니다. 따뜻하고 포근한 한국식 숙박 문화를 경험해 보세요.',
  room6_name: '스위트룸',
  room6_desc: '넓고 고급스러운 스위트 객실로, 특별한 여행을 더욱 특별하게 만들어 드립니다. 욕조와 미니바가 구비되어 있습니다.',

  // Services
  svc_tag: 'WELCOME TO THE YOUNGBIN HOTEL',
  svc_title: 'SERVICE',
  svc_subtitle: '영빈호텔이 제공하는 다양한 서비스를 경험해 보세요',
  svc1_label: '모닝콜',
  svc1_desc: '원하시는 시간에 모닝콜 서비스를 제공해 드립니다.',
  svc2_label: '24시간 컨시어지',
  svc2_desc: '24시간 언제든지 도움이 필요하시면 연락주세요.',
  svc3_label: '보안 및 관리',
  svc3_desc: '철저한 보안 시스템으로 안전한 숙박을 보장합니다.',
  svc4_label: '무료 와이파이',
  svc4_desc: '전 객실 무료 고속 와이파이를 제공합니다.',
  svc5_label: '사우나',
  svc5_desc: '피로를 풀어드리는 사우나 시설을 이용하실 수 있습니다.',
  svc6_label: '주차장',
  svc6_desc: '편리한 주차 공간을 제공해 드립니다.',

  // Reservation
  res_tag: 'RESERVATION',
  res_title: '실시간 예약',
  res_subtitle: '아래 양식을 작성하시면 빠르게 연락드리겠습니다',
  res_name: '성함',
  res_name_ph: '홍길동',
  res_phone: '연락처',
  res_phone_ph: '010-0000-0000',
  res_email: '이메일',
  res_checkin: '체크인 날짜',
  res_checkout: '체크아웃 날짜',
  res_room: '객실 유형',
  res_room1: '싱글룸',
  res_room2: '트윈룸',
  res_room3: '더블룸',
  res_room4: '트리플룸',
  res_room5: '온돌룸',
  res_room6: '스위트룸',
  res_message: '문의 사항',
  res_message_ph: '추가 문의 사항을 입력해 주세요. (최대 500자)',
  res_submit: '예약 문의 보내기',
  res_submitting: '전송 중...',
  res_success_title: '예약 문의가 접수되었습니다!',
  res_success_desc: '빠른 시일 내에 연락드리겠습니다.',

  // Contact
  contact_tag: 'WELCOME TO THE YOUNGBIN HOTEL',
  contact_title: 'CONTACT US',
  contact_address_label: '주소',
  contact_address: '서울특별시 중구 퇴계로56길 18\n(쌍림동, 영빈호텔)',
  contact_phone_label: '전화 / FAX',
  contact_email_label: '이메일',
  contact_checkinout_label: '체크인 / 체크아웃',
  contact_checkin: '체크인: 15:00',
  contact_checkout: '체크아웃: 12:00',

  // Footer
  footer_desc: '동대문 국제패션타운에 인접한 영빈호텔입니다.\n사우나, 조식제공, 동대문 쇼핑상가까지 도보 10분.',
  footer_hotel_info: '호텔 안내',
  footer_support: '고객 지원',
  footer_lang: '언어 선택',
  footer_about: '인사말',
  footer_rooms: '객실안내',
  footer_services: '부대시설',
  footer_contact: '오시는 길',
  footer_reserve: '실시간 예약',
  footer_email_inquiry: '이메일 문의',
  footer_phone_inquiry: '전화 문의',
  footer_copyright: 'Copyright © 영빈호텔. All rights reserved. | 대표: 서말남 | 서울특별시 중구 퇴계로56길 18 (쌍림동, 영빈호텔)',
  footer_privacy: '개인정보처리방침',
  footer_terms: '이용약관',
};

export default translation;
